// extracted by mini-css-extract-plugin
export var cardHeader = "_ge-1";
export var contentCard = "_ge-0";
export var headerActions = "_ge-3";
export var reorderHandle = "_ge-5";
export var titleArea = "_ge-2";
export var titleAreaWithHandle = "_ge-4";